import React from "react";
import logo from "assets/img/logo/logo_aig_login-2.png";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import LoadingScreen from "react-loading-screen";
import { urlListarDetalleComprasGeneral } from '../../constants/urls'
import { FetchPost } from '../../redux/actions/api'
import CotizacionFinalGeneral from "../../components/FinalCotizacionGeneral/ConfirmacionGeneral";
import { withToastManager } from 'react-toast-notifications';
import {urlEnviarFVinculacionCliente } from "../../constants/urls";


class FinalCotizacionGeneral extends React.Component {
  constructor(props) {
    super(props);
    const queryParams = new URLSearchParams(this.props.location.search);
    const estado=queryParams.get('estado');
    this.state = {
      loading: true,    
      datosContratante:undefined,
      datosPagador: undefined,
      datosItems:undefined ,
      planesAdvance:undefined,
      totales:undefined,
      estado:estado,
      resumen: queryParams.get('resumen'),
      infFormulario:undefined,
      isLoadingFormulario:false
    };
  }

  async componentDidMount() {
    const queryParams = new URLSearchParams(this.props.location.search);
    const id=queryParams.get('id');
    console.log("dd",id)
    //Consultar servicio para obtener la información de la compra
    let resp = await FetchPost({
      url: urlListarDetalleComprasGeneral, param: {
          empresa: "AIGMETROPOLITANA",          
          idCarrito: id
      }
  })
  const { transaccion,datosContratante, datosPagador, datosItems, datosAdicionales,totales, infFormVinculacion, planesAdvance } = resp
  if (transaccion) {
      this.setState({ datosContratante: datosContratante, datosPagador:datosPagador,  datosItems: datosItems,planesAdvance:planesAdvance, datosAdicionales, totales:totales, infFormulario:infFormVinculacion})
  }
  this.setState({ loading: false })    
  }

  onClickEnviarFormulario = async (e)  => {   
    this.setState({ isLoadingFormulario: true });  
    const { toastManager } = this.props;              
    const queryParams = new URLSearchParams(this.props.location.search);
    const idCarrito=queryParams.get('id');  

    let resp = await FetchPost({
      url: urlEnviarFVinculacionCliente+idCarrito,
      param:''
    });
    const { transaccion } = resp;    
    this.setState({ isLoadingFormulario: false });  
    if (transaccion) {   
      const content = (
        <div>   
          Se ha enviado el formulario de vinculación al correo electrónico del cliente.              
        </div>
      );       
      toastManager.add(content, {
        appearance: 'success',
      });        
    }
    else{  
      const content = (
        <div>   
          No se ha podido enviado el formulario de vinculación al correo electrónico del cliente. Por favor intente nuevamente.
        </div>
      );       
      toastManager.add(content, {
        appearance: 'warning',
      });  
    }    
  }

  render() {    
    const { loading, estado ,  datosContratante, datosPagador, datosItems,planesAdvance, datosAdicionales,totales, resumen,infFormulario, isLoadingFormulario } = this.state;  
    let verResumen=false;
    if(resumen !== undefined && resumen !== ""  && resumen !== null)  
    {
      verResumen = true
    }    

    let texto=`Cargando estado de la ${this.props.datosUsuario && this.props.datosUsuario.usu_tipo_usuario !== 'cliente'?'venta':'compra'}`;
    if(isLoadingFormulario)
    {
      texto='Enviando Formulario de Vinculación';
    }
    return (
      <LoadingScreen
      loading={loading || isLoadingFormulario}
      bgColor="#f1f1f1"
      spinnerColor="#001871"
      textColor="#676767"
      logoSrc={logo}
      text={texto}
    >
      <main className="cr-app bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
            {datosContratante  &&  datosPagador && datosItems && datosAdicionales &&  <CotizacionFinalGeneral datosContratante={datosContratante} planesAdvance={planesAdvance?planesAdvance:null} datosPagador={datosPagador} estado={estado} datosItems={datosItems} datosUsuario={this.props.datosUsuario} mostrarResumen={verResumen} datosAdicionales={datosAdicionales} totales={totales} datosFVinculacion={infFormulario} enviarFormulario={this.onClickEnviarFormulario} />}   
          </div>
        </div>
      </main>
      </LoadingScreen>
    );
  }
}

const mapStateToProps = state => ({
  datosUsuario: state.datosUsuarios.dataUsuario,
});

const mapDispatchToProps = dispatch => {
  return {
   
  };
};

export default withToastManager(withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(FinalCotizacionGeneral)
));
